import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { ModalService, AccountService, AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import { LeadSubmissionBuilder, LEAD_TYPES } from '@sm360/widget-commons-leads';

import QuoteModel from 'commons-vehicle/Quote/models/QuoteModel.js';
import VehicleService from 'commons-vehicle/Vehicle/services/VehicleService/VehicleService.js';

class AddToGarageButton extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.saveToGarage = this.saveToGarage.bind(this);
        this.addToGarageLeadUpdate = this.addToGarageLeadUpdate.bind(this);
    }

    onClick() {
        const { quote } = this.props;

        if (quote.vehicle) {
            AnalyticsService.gaTrigger(
                VehicleService.isVehicleNew(quote.vehicle)
                    ? TAGS.ADD_TO_GARAGE_CTA_NEW(quote.vehicle.model)
                    : TAGS.ADD_TO_GARAGE_CTA_USED(quote.vehicle.model)
            );
        }

        if (!AccountService.isAuthenticated()) {
            const LoginModal = ModalService.get('login/SignUpModal');
            LoginModal.addCallbacks({
                onClose: this.saveToGarage,
            });
            LoginModal.open({ quote });
        } else {
            this.saveToGarage(false);
        }
    }

    addToGarageLeadUpdate(quote) {
        return new LeadSubmissionBuilder()
            .addLeadType(LEAD_TYPES.ACCOUNT_CREATION)
            .addQuote(quote)
            .submit();
    }

    saveToGarage(withAuthentication = true) {
        const { quote } = this.props;
        if (AccountService.isAuthenticated()) {
            if (!withAuthentication && quote.vehicle && !VehicleService.isVehicleNew(quote.vehicle)) {
                this.addToGarageLeadUpdate(quote);
            }
            this.props.onClick(withAuthentication);
        }
        return true;
    }

    render() {
        const { quote } = this.props;
        const isQuoteInGarage = quote.isQuoteInGarage();
        const garageTitle = isQuoteInGarage
            ? LocaleService.t('QUOTE.BTN_APPLY_QUOTE_CHANGES')
            : LocaleService.t('QUOTE.BTN_ADD_TO_GARAGE');
        const garageButtonClasses = ['widget-vehicle-quote-btn-secondary', 'sr-button-outline-2'];
        const showButton = quote.isDirty() || !isQuoteInGarage;

        if (this.props.buttonClass) {
            garageButtonClasses.push(this.props.buttonClass);
        }
        if (quote.isDirty()) {
            garageButtonClasses.push('is-modify');
        }

        return (
            showButton && (
                <button
                    className={garageButtonClasses.join(' ')}
                    onClick={this.onClick}
                    title={garageTitle}
                    type="button"
                >
                    <icon className="icon-Mon-Garage" />
                    <span>{garageTitle}</span>
                </button>
            )
        );
    }
}

AddToGarageButton.defaultProps = {
    buttonClass: '',
};

AddToGarageButton.propTypes = {
    buttonClass: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(QuoteModel).isRequired,
};

AddToGarageButton.displayName = 'AddToGarageButton';

export default AddToGarageButton;



// WEBPACK FOOTER //
// ./src/Quote/components/AddToGarage/AddToGarageButton.jsx